import React, { useEffect, useState } from 'react';
import { supabaseAdmin } from '../config/supabase';
import toast from 'react-hot-toast';

export default function TabsManagement() {
  const [tabs, setTabs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadTabs();
  }, []);

  const loadTabs = async () => {
    try {
      setLoading(true);
      const { data, error } = await supabaseAdmin
        .from('app_tabs')
        .select('*')
        .order('order', { ascending: true });

      if (error) throw error;
      setTabs((data || []).filter(tab => tab.key !== 'attractions'));
    } catch (error) {
      toast.error('Błąd podczas ładowania zakładek');
      console.error('Error loading tabs:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleToggleVisibility = async (tab) => {
    try {
      const newVisible = !tab.visible;
      const { error } = await supabaseAdmin
        .from('app_tabs')
        .update({ visible: newVisible })
        .eq('id', tab.id);

      if (error) throw error;

      // Update local state
      setTabs(prevTabs =>
        prevTabs.map(t => (t.id === tab.id ? { ...t, visible: newVisible } : t))
      );

      toast.success(
        newVisible
          ? `Zakładka "${tab.label}" została włączona`
          : `Zakładka "${tab.label}" została wyłączona`
      );
    } catch (error) {
      toast.error('Błąd podczas aktualizacji zakładki');
      console.error('Error updating tab:', error);
    }
  };

  if (loading) {
    return (
      <div style={{ padding: '20px', textAlign: 'center' }}>
        <p>Ładowanie zakładek...</p>
      </div>
    );
  }

  return (
    <div style={{ padding: '20px' }}>
      <h1 style={{ marginBottom: '24px' }}>Zarządzanie zakładkami</h1>
      <p style={{ marginBottom: '24px', color: '#666' }}>
        Włącz lub wyłącz zakładki w aplikacji mobilnej. Zmiany są natychmiast widoczne w aplikacji.
      </p>

      <div
        style={{
          backgroundColor: '#fff',
          borderRadius: '8px',
          boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
          overflow: 'hidden',
        }}
      >
        <table
          style={{
            width: '100%',
            borderCollapse: 'collapse',
          }}
        >
          <thead>
            <tr
              style={{
                backgroundColor: '#f5f5f5',
                borderBottom: '2px solid #e0e0e0',
              }}
            >
              <th
                style={{
                  padding: '12px 16px',
                  textAlign: 'left',
                  fontWeight: '600',
                  color: '#333',
                }}
              >
                Zakładka
              </th>
              <th
                style={{
                  padding: '12px 16px',
                  textAlign: 'center',
                  fontWeight: '600',
                  color: '#333',
                  width: '120px',
                }}
              >
                Widoczna
              </th>
            </tr>
          </thead>
          <tbody>
            {tabs.length === 0 ? (
              <tr>
                <td
                  colSpan="2"
                  style={{
                    padding: '24px',
                    textAlign: 'center',
                    color: '#999',
                  }}
                >
                  Brak zakładek
                </td>
              </tr>
            ) : (
              tabs.map((tab) => (
                <tr
                  key={tab.id}
                  style={{
                    borderBottom: '1px solid #e0e0e0',
                  }}
                >
                  <td
                    style={{
                      padding: '16px',
                      color: '#333',
                    }}
                  >
                    <div>
                      <strong>{tab.label}</strong>
                      <div
                        style={{
                          fontSize: '12px',
                          color: '#666',
                          marginTop: '4px',
                        }}
                      >
                        Route: {tab.route_name} | Key: {tab.key}
                      </div>
                    </div>
                  </td>
                  <td
                    style={{
                      padding: '16px',
                      textAlign: 'center',
                    }}
                  >
                    <label
                      style={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        cursor: 'pointer',
                      }}
                    >
                      <input
                        type="checkbox"
                        checked={tab.visible}
                        onChange={() => handleToggleVisibility(tab)}
                        style={{
                          width: '20px',
                          height: '20px',
                          cursor: 'pointer',
                        }}
                      />
                    </label>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
